interface XlsxAttachmentParams {
  xlsBlob: Blob;
  filename: string;
}

interface EmailAttachment {
  filename: string;
  content: string;
  contentType: string;
}

/**
 * Creates an XLSX email attachment from a blob
 * @param xlsBlob - XLSX blob to convert
 * @param filename - Desired filename for the attachment
 * @returns Email attachment object with base64 content
 */
export const createXlsxAttachment = async ({
  xlsBlob,
  filename
}: XlsxAttachmentParams): Promise<EmailAttachment> => {
  const base64xls = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(xlsBlob);
  });

  return {
    filename,
    content: base64xls.split('base64,')[1],
    contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  };
};

